import React, { useEffect, useRef, useState } from "react";
import { AutoComplete } from "rsuite";
import { ItemDataType } from "rsuite/esm/@types/common";

type HandleSelectType = (
  value: any,
  item: ItemDataType<string | number>,
  event: React.SyntheticEvent<Element, Event>
) => void;

interface Data {
  name?: string;
  isoCode?: string;
  countryCode?: string;
  Name?: string | null;
  Id?: number | null;
  SourceName?: string | null;
  SourceId?: number | null;
  RequirementId?: number;
  RequirementTitle?: string;
  EmployeeId?: string | null;
  FirstName?: string | null;
  LastName?: string | null;
  TotalExperience?: number;
}

interface Props {
  data: Data[];
  defaultValue?: number | null | string;
  onSelect: HandleSelectType;
  label: string;
  onChange?: any;
  isValidate?: boolean;
  value?: number | null | string;
  placeholder?: string;
  EvaluationId?: number;
  onKeyPress?: any;
}

export const EPAutoComplete: React.FC<Props> = ({
  data,
  defaultValue,
  onSelect,
  label,
  onChange,
  isValidate,
  value,
  placeholder,
  EvaluationId,
  onKeyPress,
}) => {
  let dataList: any;
  let filteredObject: any;
  const autoCompleteRef = useRef<any>(null);
  const delayedDataListRef = useRef<boolean>(false);
  const [delay, setDelay] = useState(false);

  useEffect(() => {
    const autoCompleteInstance = autoCompleteRef.current?.getInstance();
    if (autoCompleteInstance) {
      setTimeout(() => {
        autoCompleteInstance.setValue(defaultValue || "");
      }, 10);
    }
  }, [defaultValue]);
  
  useEffect(() => {
    const timeout = setTimeout(() => {
      setDelay(true);
    }, 800);
    return () => clearTimeout(timeout);
  }, []);
  if (label === "requirementMapping") {
    dataList = data?.map((item: Data) => ({
      label: `${item.RequirementTitle} (${item.RequirementId})`,
      value: `${item.RequirementTitle} (${item.RequirementId})`,
      id: item.RequirementId,
    }));
    filteredObject = dataList?.find((item: any) => {
      if (item.id === defaultValue) {
        return item;
      }
    })?.value;
  } else if (label === "ReferenceBy") {
    dataList =
      data &&
      data?.map((item: Data) => ({
        label: item.FirstName,
        value: item.FirstName,
        id: item.EmployeeId,
      }));
  
    filteredObject = dataList?.find((item: any) => {
      if (item.id === defaultValue) {
        return item;
      }
    })?.value;
  } else if (label === "Technology") {
    dataList = data?.map((item: Data) => ({
      label: item.Name,
      value: item.Id,
      id: item.Id,
    }));
  } else if (label === "ReferedBy") {
    dataList = data?.map((item: Data) => {
      if (item?.FirstName) {
        return {
          label: item.FirstName,
          value: item.FirstName,
          id: item.EmployeeId,
          referedBy: "Employee",
        };
      } else {
        return {
          label: item?.SourceName,
          value: item?.SourceName,
          id: item?.SourceId,
          referedBy: "Source",
        };
      }
    });
    filteredObject = dataList?.find((item: any) => {
      if (item.id === defaultValue) {
        return item;
      }
    })?.value;
  } else if (
    label === "PrimaryInterviewer" ||
    label === "SecondaryInterviewer"
  ) {
    dataList =
      data &&
      data?.map((item: Data) => ({
        label: `${item.FirstName} ${item.LastName ? item.LastName : ""}`,
        value: `${item.FirstName} ${item.LastName ? item.LastName : ""}`,
        id: item.EmployeeId,
        InterviewerType: label,
      }));
  }
  return (
    <>
      {delay && dataList?.length > 0 && (
        <AutoComplete
          placeholder={placeholder}
          data={dataList}
          defaultValue={filteredObject || ""}
          labelKey="label"
          onSelect={onSelect}
          valueKey="value"
          onChange={(value, event) => {
            onChange(value, event);
          }}
          className={!value && isValidate ? "border border-danger" : ""}
          onKeyPress={onKeyPress}
        />
      )}
    </>
  );
};
